import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3476">
      <Navbar data-id="element-3477" />
      <main data-id="element-3478">
        <ConsularAffairs data-id="element-3479" />
      </main>
      <Footer data-id="element-3480" />
    </div>;
}